<template>


   <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>Locum Dashboard</ion-title>
        </ion-toolbar>
  <div class="main_wrapper ion-padding ">
    <div class="container">
    <div class="s-total-amout">
        Total Amount Earned  <strong> <i class="el-icon-right"></i>  {{ totalEarn }} </strong><span class="fiscal-margin">Current fiscal year</span>
    </div>
    <div class="relative" v-if="initalEarnings.length > 0">
      <OverAllBarChart :initial="initalEarnings"/>
      <p class="text-center chart-title">Pharmacies</p>
    </div>
    <div>
        <div class="s-title">Summary Report</div>
        
        <div class="report-center">
          <div class="s-report">
            <div>Total Net Amount: <strong> {{ totalNetAmount }}</strong></div>
            <div>Total GST: <strong> {{ totalGst }}</strong></div>
            <div v-if="isAustralia">Total Super: <strong>{{ totalSuper }}</strong> </div>
            <div>Total Travel: <strong> {{ totalTravel }}</strong></div>
        </div>
        </div>
       
    </div>
    <div class="advance-filter s-advance-filter">
        <el-button @click="toggleText">{{ buttonText }}</el-button>
    </div>
        
   
    <el-form
        class="full_page s-el-form"
        :model="formsData.userForm"
        :rules="formsData.userForm.rules"
        :ref="(el) => (formsData.userForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="goNext('userForm')"
    >
    <div class="form_text" v-if="showText">
          <div class="text">
            Select Date Range
          </div>
        </div>
        <div class="el-form-wrap">
          <el-form-item
          prop="filterDate"
          label="From"
          :required="true"
          v-if="showText"
      >
      
        <el-date-picker
            popper-class="datepicker_popper drawer-style-ahpra"
            type="date"
            :format="$filters.systemDateFormat()"
            placeholder="Pick a date"
            v-model="formsData.userForm.filterDate.value.fromDate"
            @blur="checkFormValidation('userForm', true, 'filterDate')"
            style="width: 100%;"
            class="custom-date-picker"
            
        ></el-date-picker>
      </el-form-item>
      <el-form-item
          prop="filterDate"
          label="To"
          :required="true"
          v-if="showText"
      >
        <el-date-picker
            popper-class="datepicker_popper drawer-style-ahpra"
            :format="$filters.systemDateFormat()"
            placeholder="Pick a date"
            v-model="formsData.userForm.filterDate.value.toDate"
            style="width: 100%;"
            @blur="checkFormValidation('userForm', true, 'filterDate')"
            class="custom-date-picker"
        ></el-date-picker>
      </el-form-item>

        <el-form-item class="button_submit mb0" v-if="showText">
          <el-button class="submit" type="blue" :disabled="!formsData.userForm.isFormValid" @click="goNext('userForm')">
            <span>Filter</span>
            
          </el-button>
        </el-form-item>
        </div>

     

    </el-form>

    <div v-if="filterRespData.earnings.length > 0 && showText">
      <div class="s-mb">
        <div class="s-title ">Summary Report</div>
        
        <div class="s-report-card">
          <div class="text-center total-mb">Total Amount Earned: <strong>{{ Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(overAllEarningData.overallEarnings) }}</strong></div>
          <div class="report-center">
            <div class="s-report">
              <div>Total Net Amount: <strong>{{ Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(overAllEarningData.totalNetAmount) }}</strong></div>
              <div>Total GST: <strong> {{ Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(overAllEarningData.overallGst) }}</strong></div>
              <div v-if="isAustralia">Total Super: <strong>{{ Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(overAllEarningData.overallSuper) }}</strong> </div>
              <div>Total Travel: <strong>{{ formatTravelWithDistance(overAllEarningData.overallTravelCompensation, overAllEarningData.overallTravelDistance) }} </strong></div>
          </div>
          </div>
        
           
        </div>
    </div>
    <div class="responsive-overflow relative" >
      <StackedBarChart :data="pharmacyEarnings"/>
      <p class="chart-title">Pharmacies</p>
    </div>
    </div>

    
    <div v-if="showText">
      <div class="detail-outer" v-if="filterRespData.earnings.length > 0">
        <div class="s-title ">Detail Report</div>
        <div> 
          <ion-button class="button_back" @click="downloadPDF()">
              <ion-icon name="download-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
      
      <div class="table-responsive earning-table">
      <el-table class="table centered-table table-content-left"  :data="filterRespData.earnings" :stripe="true" style="width: 100%">
          <el-table-column prop="name" label="Pharmacy">
            <template #default="scope">
              <div class="clickable-cell clickable-cell-mb" @click="showShiftsDialog(scope.row)">
                <div class="clickable-cell-left"> {{ scope.$index + 1 }}.</div> 
                <div class="clickable-cell-right text-underline">{{ scope.row.name }}</div>
              </div>
              
                <span class="column-left-all fs-13">
                  Total Shift: {{  scope.row.total.shiftCount }}<br>
                  Total GST: {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(scope.row.total.totalGst)}} <br>
                  <template v-if="isAustralia">
                    Total Super Amount: {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(scope.row.total.totalSuperAmount)}}<br>
                  </template>
                  Total Travel Compensation: {{ formatCurrency(scope.row.total.totalTravelCompensation) }}<br>
                  Total Travel Distance: {{ formatTravelDistance(scope.row.total.totalTravelDistance) }}<br>
                  Net Amount: {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(scope.row.total.totalAmount)}}
                </span>
              
            </template>
          </el-table-column>
          <el-table-column label="Total Amount Earned">
            <template #default="scope">
              <span>{{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(scope.row.total.totalEarning)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>


    <el-dialog v-model="dialogVisible" title="Shift Details" :width="dialogWidth" :before-close="resetDialog">
      <div class="table-container" style="width: 100%; overflow-x: auto;">
        <el-table :data="selectedShifts" :row-key="getRowKey" :stripe="true">
          <el-table-column prop="date" label="Date" width="105">
            <template #default="{ row }">
              {{ $moment(row.date, "YYYY/MM/DD").format("D MMM, YYYY") }}
            </template>
          </el-table-column>
          <el-table-column prop="workingHours" label="Hours" width="65"></el-table-column>
          <el-table-column prop="amount" label="Amount" width="80">
            <template #default="{ row }">
              {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(row.amount)}}
            </template>
          </el-table-column>
          <el-table-column prop="gst" label="GST" width="80">
            <template #default="{ row }">
              {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(row.gst)}}
            </template>
          </el-table-column>
          <el-table-column prop="travelCompensation" label="Travel" width="120">
            <template #default="{ row }">
              {{ formatTravelWithDistance(row.travelCompensation, row.travelDistance) }}
            </template>
          </el-table-column>
          <el-table-column prop="superAmount" label="Super" width="80" v-if="isAustralia">
            <template #default="{ row }">
              {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(row.superAmount)}}
            </template>
          </el-table-column>
          <el-table-column prop="earning" label="Total" width="90">
            <template #default="{ row }">
              {{Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(row.earning)}}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer dialog-footer-center">
        <el-button class="el-button--blue el-button--sm" @click="dialogVisible = false">Close</el-button>
      </div>
    </el-dialog>
  </div>

  
</template>

<script>
    import { instance as axios } from "@/hooks/axios/axios.js";

import {onMounted, inject, ref,onBeforeMount } from "vue";
import formHooks from "@/hooks/form/form";
import {addIcons} from "ionicons";
import {arrowBackOutline,downloadOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
  'download-outline': downloadOutline
});
import {IonToolbar, IonButton, IonButtons, IonIcon,IonTitle} from "@ionic/vue";
import {useStore} from "vuex";
import formValidate from "@/hooks/form/validate/validate";
import {useRouter, useRoute} from "vue-router";
import StackedBarChart from './StackedBarChart.vue';
import OverAllBarChart from "./OverAllBarChart.vue";
import { ElDialog, ElButton, ElTable, ElTableColumn } from 'element-plus';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    ElDialog,
    ElButton,
    ElTable,
    ElTableColumn,
    StackedBarChart,
    OverAllBarChart
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject(["setPageClassGlobal"]);
    const $moment = inject(["$moment"]);
    const routeName = $route.name;
    const userData = $store.getters.GET_USER_DATA;
    const totalEarn = ref("loading...");
    const totalNetAmount = ref("loading...");
    const totalGst = ref("loading...");
    const totalSuper = ref("loading...");
    const totalTravel = ref("loading...");
    const formatCurrency = (amount) =>
      Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(amount || 0);
    const formatTravelDistance = (distance) =>
      `${parseFloat(Number(distance || 0).toFixed(2))}km`;
    const formatTravelWithDistance = (amount, distance) =>
      `${formatCurrency(amount)} (${formatTravelDistance(distance)})`;
    let initalEarnings = ref({});
    let tableData = ref({invoices: []});
    let filterRespData = ref({earnings:[]});
    let overAllEarningData = ref({});
    let pharmacyEarnings = ref({});
    const isAustralia = isAustraliaRegion();

    const chartData = ref({
      labels: ['A', 'B', 'C'],
      datasets: [
        {
          label: 'Dataset 1',
          data: [10, 20, 30],
        },
        {
          label: 'Dataset 2',
          data: [15, 25, 35],
        },
      ],
    });

    const chartOptions = ref({
      responsive: true,
      maintainAspectRatio: false,
    });

    const dialogVisible = ref(false);
    const selectedShifts = ref([]);
    const dialogWidth = ref('60%');
    const tableHeight = ref('300px');    
    const requestParams = {
        per_page: 10,
        page: 1,
    }



    const showText = ref(false);
    const buttonText = ref('Show Advance Filter');
    

    const toggleText = () => {
      showText.value = !showText.value;
      buttonText.value = showText.value ? 'Hide Advance Filter' : 'Show Advance Filter';
      };
    const formsDataArray = {
      userForm: {
        filterDate: {
          ref: null,
          value: {
            fromDate: "",
            toDate: "",
          },
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                    rule,
                    formField,
                    {
                      rule: "filterDate",
                    },
                    callback,
                    setFormValidation
                );
              },
            },
          ],
        },
      },
    };



    const goBack = () => {
    
      $router.push({
                    name: 'profile'
                })
    };

    const goNext = (formName) => {
      console.log(formName);
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              const formValues = getFormValues(formName);
              console.log("form valueueueue", formValues);
              const params = {
                
                from_date:$moment(formValues.filterDate.fromDate, "DD/MM/YYYY").format(
                      "YYYY-MM-DD"
                    ),
                    
                to_date:$moment(formValues.filterDate.toDate, "DD/MM/YYYY").format(
                      "YYYY-MM-DD"
                    ),
              }
              let filterData = await axios.get(userData.role + "/"+ userData.id +"/total-shifts-earnings", {
                    params: params
                })
                console.log("filters data are",filterData.data.data);
                filterRespData.value.earnings = filterData.data.data.perPharmacyEarnings;
                overAllEarningData.value = filterData.data.data.overallEarnings;
                pharmacyEarnings.value = filterData.data.data;
            
            } catch (error) {
              console.log(error);
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };


    const showShiftsDialog = (row) => {
      
      selectedShifts.value = row.allShift;
      dialogVisible.value = true;
    };

    const resetDialog = () => {
      dialogVisible.value = false
      selectedShifts.value = [];
    };

      const downloadPDF = async () => {
        const formValues = getFormValues('userForm');
              console.log("form valueueueue", formValues);
              const params = {
                
                from_date:$moment(formValues.filterDate.fromDate, "DD/MM/YYYY").format(
                      "YYYY-MM-DD"
                    ),
                    
                to_date:$moment(formValues.filterDate.toDate, "DD/MM/YYYY").format(
                      "YYYY-MM-DD"
                    ),
              }
          axios({
            url: `${userData.role}/${userData.id}/generate-report`,
              method: 'GET',
              responseType: 'blob', // important
              params: params
          }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'report.csv');
              document.body.appendChild(link);
              link.click();
          });
      };


 const getLabel = (key) => {
      let labels = {};
      if(isAustralia.value){
        labels = {
        shiftCount: "Total Shift",
        totalGst: "Total GST",
        totalSuperAmount: "Total Super Amount",
        totalTravelCompensation: "Total Travel Compensation"
      };
      }else{
        labels = {
        shiftCount: "Total Shift",
        totalGst: "Total GST",
        totalTravelCompensation: "Total Travel Compensation"
      };
      }
      

      return labels[key] || "";
    };

    const shouldDisplay = (key) => {
      let displayProperties = [];
      if(isAustralia.value){
        displayProperties = ["total_gst", "total_travel_compensation", "total_super_amount"];
      }else{
        displayProperties = ["total_gst", "total_travel_compensation"];

      }
      return displayProperties.includes(key);
    };

onMounted(() => {
  setPageClassGlobal("total_earn_page");
  setFormRefs();
  formsRefs.userForm.value.$el[0].focus();
  checkFormValidation("userForm", false);
});


onBeforeMount(async () => {
      return new Promise((resolve) => {
        $store
          .dispatch("GET_EARNING_DASHBOARD")
          .then((response) => {
           
            let jobFetchResult = response.data;
            totalEarn.value = Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(jobFetchResult.overallEarnings.overallEarnings);
            totalNetAmount.value =  Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(jobFetchResult.overallEarnings.totalNetAmount);
            totalGst.value = Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(jobFetchResult.overallEarnings.overallGst);
            totalSuper.value = Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(jobFetchResult.overallEarnings.overallSuper);
            totalTravel.value = formatTravelWithDistance(
              jobFetchResult.overallEarnings.overallTravelCompensation,
              jobFetchResult.overallEarnings.overallTravelDistance
            );
            initalEarnings.value = jobFetchResult.perPharmacyEarnings;
            resolve(response);
          });
      });
    });



const {
  checkFormValidation,
  setFormValidation,
  setFormRefs,
  getFormValues,
  formsData,
  formsRefs,
} = formHooks(formsDataArray);

return {
  formsData,
  goBack,
  goNext,
  checkFormValidation,
  routeName,
  getFormValues,
  getLabel,
  shouldDisplay,
  showText,
  buttonText,
  toggleText,
  tableData,
  requestParams,
  downloadPDF,
  totalEarn,
  totalGst,
  totalSuper,
  totalTravel,
  formatCurrency,
  formatTravelDistance,
  formatTravelWithDistance,
  filterRespData,
  dialogVisible,
  selectedShifts,
  showShiftsDialog,
  dialogWidth,
  tableHeight,
  resetDialog,
  overAllEarningData,
  chartData,
  chartOptions,
  pharmacyEarnings,
  initalEarnings,
  totalNetAmount,
  isAustralia
};
},
}
;
</script>